import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge9 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の損益通算は、２０１４年４月以降廃止に' fontWeight={700} />
                <p>個人でのゴルフ会員権の損益通算について解説する前に、まずは損益通算の概要について解説します。</p>

                <Heading3 title='そもそも、損益通算とは' />
                <p>
                    損益通算とは、売買などによって損失が発生した場合に、各所得金額から控除すること。
                    <br />
                    特定の物品の取引において、購入価格より売却価格が低くなることで発生した損失は、その差額を所得金額から控除することが出来ます。
                    <br />
                    つまり、損失が出た場合は確定申告により、所得税の還付や住民税の減額を受けられるので、売却により損失が出た場合でも、控除により実質的に損失を軽減出来るのです。
                </p>

                <Heading3 title='２０１４年４月以降、ゴルフ会員権の譲渡で売却損が出ても損益通算ができないことに' />
                <p>
                    ところが２０１４年４月から損益通算の内容が改訂され、ゴルフ会員権の売却にともなう損失は控除対象ではなくなりました。
                    <br />
                    これにより、売却損が出たとしても税制面でのメリットがなくなってしまい、それにともない確定申告も不要となりました。
                    <br />
                    実はこの改正案が持ち上がってから施行されるまでに、とても長い年月がかかっているのですが、その経緯については次項にてご紹介します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の損益通算廃止の経緯' fontWeight={700} />
                <p>
                    なぜ、ゴルフ会員権の売却損は控除できなくなったのでしょうか。その経緯について、順を追って見ていきましょう。
                </p>

                <Heading3 title='ゴルフ会員権の損益通算廃止案が持ち上がる（２０００年ごろ）' />
                <p>
                    損益通算では、個人で保有する書画や古美術品、競走馬、貴金属のようないわゆる「ぜいたく品」は、生活を送る上で必ずしも必要な資産ではないとされており、売却時に発生した損失も他の所得と相殺出来ませんでした。
                    <br />
                    損益通算に「ぜいたく品」の規定ができた時点においては、会員権はその対象として含まれていませんでした。
                    <br />
                    このような状況において、「実態を踏まえつつ検討を加えることが必要」との考えのもと、法改正が検討され始めました。
                </p>

                <Heading3 title='業界団体からの反発により、ゴルフ会員権の損益通算廃止案が見送られる（２００５年～２０１３年）' />
                <p>
                    これに対し、業界団体からは当然ながら反発が起こります。
                    <br />
                    業界団体の言い分としては、「損益通算が出来なくなることによる会員権相場の下落が予想される」こと、「市場売却ではなく、ゴルフ場側に預託金の返還請求をする会員が続出する恐れがある（これによりゴルフ場経営自体が立ち行かなくなってしまう）」ことを挙げていました。
                    <br />
                    業界団体からの反発は大きく、廃止案はいったん見送りとなりましたが、これ以降「閣議により損益通算廃止案が持ち上がるが、反発が大きいため見送る」といったことを約１０年弱もの間に何度も繰り返してきたのです。
                </p>

                <Heading3 title='税制改正大綱が閣議決定され、損益通算廃止がほぼ確実に（２０１３年１２月）' />
                <p>
                    しかし、２０１３年１２月に税制改正大綱が閣議決定されたことを受けて、損益通算の廃止もまた決定的となります。
                    <br />
                    これにより、趣味、娯楽、保養または鑑賞の目的で所有する資産に対しその内容が改訂されることとなり、ゴルフ会員権の売却による損失も控除の対象から外されました。
                </p>

                <Heading3 title='ゴルフ会員権の損益通算が廃止される（２０１４年４月）' />
                <p>
                    このような流れにより、ゴルフ会員権は２０１４年３月３１日までの譲渡（売却）によって生じた損失に対してのみ損益通算が可能とし、２０１４年４月からは控除できなくなってしまったのです。
                    <br />
                    ※詳細については国税庁ＨＰを参照
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='損益通算廃止後のゴルフ会員権売却を有利に行うポイント' fontWeight={700} />
                <p>
                    それでは、売却損をなるべく抑えるために、ゴルフ会員権の売却を有利に行うにはどのような点に注意すれば良いのでしょうか。
                </p>

                <Heading3 title='利用しない場合は、早めに売却を検討する' />
                <p>
                    ゴルフ会員権は利用しなかったとしても、年会費などの維持費がかかってしまいますし、タイミングによっては売却額が下がってしまうかもしれません。
                    <br />
                    利用の予定がないのであれば、維持費を考えた場合、早めに売却を検討する方が良いでしょう。
                </p>

                <Heading3 title='実績があり、信頼できるゴルフ会員権業者を選ぶ' />
                <p>
                    最近では、専門業者による華やかなホームページが用意されていることが多く、また注目を集めるために高い見積額を提示するなど、顧客をつかむための手段も多彩になってきましたが、その業者の本質が現れるのはホームページのような表面的な部分よりも、電話での応対であったり、資料やメールマガジンの内容であったりします。
                    <br />
                    そのため、多くの実績があり信頼のできる業者を選ぶことが、顧客にとってベストな選択肢となります。
                </p>

                <Heading3 title='複数の会員権業者に売却を依頼しない' />
                <p>
                    市場に売り物件が増えれば増えるほど、市場相場は下がる方向にあります。
                    <br />
                    買う側であれば多くの業者に見積を出してもらい、価格競争をさせることは有効な手段となり得ますが、売る側となる場合はそれらが逆転するため、信頼できる会員権業者に絞って依頼すべきです。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の売買に関するお問合せは住地ゴルフに' fontWeight={700} />
                <p>
                    ２０１４年４月よりゴルフ会員権の売却損は控除の対象から外されたため、売却損は出来る限り抑える必要があります。
                    <br />
                    そのため、より良い条件で売却出来るように、信頼できる業者選びが重要な要素になってきました。
                    <br />
                    ゴルフ会員権の売却をお考えなら住地ゴルフにお任せください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge9;
